<template>
  <div class="tabs-container ng-scope" style="padding-bottom: 50px; margin-top: 18px">
    <form method="get" class="form-horizontal" id="baseInfo" novalidate="novalidate">
      <div class="tab-content">
        <div>
          <div class="panel-body">
            <div class="ibox-content">
              <div class="row">
                <div class="col-sm-12">
                  <div class="ibox homePage">
                    <div class="ibox-title" style="height: 60px">
                      <div class="btn btn-primary pull-right" style="margin-left: 10px" @click="publishEvent()">
                        {{ $t("message.Publish") }}
                      </div>
                      <div class="btn btn-primary pull-right" style="margin-left: 10px" @click="saveEvent()">
                        {{ $t("message.Save as draft") }}
                      </div>
                    </div>

                    <div class="row" style="margin-left: 0px; margin-right: 0px">
                      <div class="col-sm-12 content-row">
                        <div class="bannerLabel">
                          {{ $t("message.topBanner") }}
                        </div>
                        <div style="width: 180px;">
                          <div>
                            <select class="form-control" v-model="topBannerId" name="topBannerId">
                              <option value="">
                                {{ $t("message.PleaseSelect") }}
                              </option>
                              <option v-for="topBanner in topBannerList" :value="topBanner.id" :key="topBanner.id">
                                {{ topBanner["topBannerName" + $i18n.locale] }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="btn-group">
                          <div class="btn btn-primary" @click="addTopBanner()">
                            {{ $t("message.Add Banner") }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row" style="margin-left: 0px; margin-right: 0px">
                      <div class="col-sm-12 content-row">
                        <div class="bannerLabel">
                          {{ $t("message.floatingBanner") }}
                        </div>
                        <div style="width: 180px;">
                          <div>
                            <select class="form-control" v-model="floatingBannerId" name="floatingBannerId">
                              <option value="">
                                {{ $t("message.PleaseSelect") }}
                              </option>
                              <option v-for="floatingBanner in floatingBannerList" :value="floatingBanner.id" :key="floatingBanner.id">
                                {{ floatingBanner["bannerName" + $i18n.locale] }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="btn-group">
                          <div class="btn btn-primary" @click="addFloatingBanner()">
                            {{ $t("message.Add Banner") }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row" style="margin-left: 0px; margin-right: 0px">
                      <div class="col-sm-12 content-row">
                        <div class="bannerLabel">
                          {{ $t("message.departmentBanner") }}
                        </div>
                        <div style="width: 180px;">
                          <div>
                            <select class="form-control" v-model="departmentBannerId" name="departmentBannerId">
                              <option value="">
                                {{ $t("message.PleaseSelect") }}
                              </option>
                              <option v-for="departmentBanner in departmentBannerList" :value="departmentBanner.id" :key="departmentBanner.id">
                                {{ departmentBanner["bannerName" + $i18n.locale] }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="btn-group">
                          <div class="btn btn-primary" @click="addDepartmentBanner()">
                            {{ $t("message.Add Banner") }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row" style="margin-left: 0px; margin-right: 0px">
                      <div class="col-sm-12 content-row">
                        <div class="bannerLabel">
                          {{ $t("message.Career magazine") }}
                        </div>
                        <div style="width: 180px;">
                          <div>
                            <select class="form-control" v-model="articleId" name="articleId">
                              <option value="">
                                {{ $t("message.PleaseSelect") }}
                              </option>
                              <option v-for="article in articleList" :value="article.id">
                                {{ article["title" + $i18n.locale] }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="btn-group">
                          <!-- <div class="btn btn-primary" @click="addBanner()">
                            {{ $t("message.Add Banner") }}
                          </div> -->
                          <div class="btn btn-primary" @click="addArticle()">
                            {{ $t("message.Add magazine") }}
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div class="ibox-content">
              <div class="row">
                <div class="col-sm-12">
                  <div class="ibox homePage">
                    <!-- <div class="ibox-title" style="height: 60px">
                      <div class="btn btn-primary pull-right" style="margin-left: 10px" @click="publishEvent()">
                        {{ $t("message.Publish") }}
                      </div>
                      <div class="btn btn-primary pull-right" style="margin-left: 10px" @click="saveEvent()">
                        {{ $t("message.Save as draft") }}
                      </div>
                      <div class="btn btn-primary pull-right" style="margin-left: 10px" @click="addArticle()">
                        {{ $t("message.Add hot picks") }}
                      </div>
                      <div class="btn btn-primary pull-right" style="margin-left: 10px" @click="addBanner()">
                        {{ $t("message.Add Banner") }}
                      </div>
                      <div class="pull-right" style="width: 180px; padding-right: 10px">
                        <div>
                          <select class="form-control" v-model="articleId" name="articleId">
                            <option value="">
                              {{ $t("message.PleaseSelect") }}
                            </option>
                            <option v-for="article in articleList" :value="article.id">
                              {{ article["title" + $i18n.locale] }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div> -->
                    
                    <div class="ibox-content">
                      <div class="row">
                        <div class="col-sm-5" style="height: 900px;max-width: 450px;min-width: 320px;">
                          <iframe id="landingPage" width="100%" height="800px"></iframe>
                        </div>
                        <div class="col-sm-7">
                          <div class="listTab">

                            <!-- <div>{{ $t("message.Banner") }}</div>
                            <draggable
                              class="sortable-list connectList0 agile-list"
                              style="max-height: 900px; overflow: auto; margin-bottom: 15px;"
                              v-model="homePageObj.bannerList"
                              group="people"
                              @start="drag = true"
                              @end="drag = false">
                              <div v-for="(task, index) in homePageObj.bannerList" class="dragObj">
                                <div style="padding: 5px">
                                  <span style="display: inline-block">
                                    {{ $t("message.Article title:") }}
                                    {{ task["title" + $i18n.locale] }}
                                  </span>
                                </div>
                                <a
                                  class="pull-right btn btn-xs btn-white"
                                  style="position: absolute; top: 10px; right: 10px;"
                                  @click="deleteBanner(index)"
                                  >{{ $t("message.Delete") }}
                                </a>
                              </div>
                            </draggable> -->

                            <div>{{ $t("message.TopBannerNum") }}</div>
                            <draggable
                              class="sortable-list connectList0 agile-list"
                              v-model="homePageObj.topBannerVoList"
                              style="max-height: 900px; overflow: auto; margin-bottom: 15px;"
                              group="topBanner"
                              @start="drag = true"
                              @end="drag = false"
                            >
                              <div v-for="(topBanner, index) in homePageObj.topBannerVoList" class="dragObj" :key="index">
                                <div style="padding: 5px">
                                  <span style="display: inline-block">
                                    {{ $t("message.TopBanner name:") }}
                                    {{ topBanner["topBannerName" + $i18n.locale] }}
                                  </span>
                                </div>
                                <a
                                  class="pull-right btn btn-xs btn-white"
                                  style="position: absolute; top: 10px; right: 10px;"
                                  @click="deleteTopBanner(index)"
                                >
                                  {{ $t("message.Delete") }}
                                </a>
                              </div>
                            </draggable>

                            <div>{{ $t("message.FloatingBannerNum") }}</div>
                            <draggable
                              class="sortable-list connectList0 agile-list"
                              v-model="homePageObj.floatingBannerVoList"
                              style="max-height: 900px; overflow: auto; margin-bottom: 15px;"
                              group="topBanner"
                              @start="drag = true"
                              @end="drag = false"
                            >
                              <div v-for="(floatingBanner, index) in homePageObj.floatingBannerVoList" class="dragObj" :key="index">
                                <div style="padding: 5px">
                                  <span style="display: inline-block">
                                    {{ $t("message.FloatingBanner name:") }}
                                    {{ floatingBanner["bannerName" + $i18n.locale] }}
                                  </span>
                                </div>
                                <a
                                  class="pull-right btn btn-xs btn-white"
                                  style="position: absolute; top: 10px; right: 10px;"
                                  @click="deleteFloatingBanner(index)"
                                >
                                  {{ $t("message.Delete") }}
                                </a>
                              </div>
                            </draggable>

                            <div>{{ $t("message.DepartmentBannerNum") }}</div>
                            <draggable
                              class="sortable-list connectList0 agile-list"
                              v-model="homePageObj.departmentBannerVoList"
                              style="max-height: 900px; overflow: auto; margin-bottom: 15px;"
                              group="topBanner"
                              @start="drag = true"
                              @end="drag = false"
                            >
                              <div v-for="(departmentBanner, index) in homePageObj.departmentBannerVoList" class="dragObj" :key="index">
                                <div style="padding: 5px">
                                  <span style="display: inline-block">
                                    {{ $t("message.DepartmentBanner name:") }}
                                    {{ departmentBanner["bannerName" + $i18n.locale] }}
                                  </span>
                                </div>
                                <a
                                  class="pull-right btn btn-xs btn-white"
                                  style="position: absolute; top: 10px; right: 10px;"
                                  @click="deleteDepartmentBanner(index)"
                                >
                                  {{ $t("message.Delete") }}
                                </a>
                              </div>
                            </draggable>
                            
                            <div>{{ $t("message.Career magazineNum") }}</div>
                            <draggable
                              class="sortable-list connectList0 agile-list"
                              style="max-height: 900px; overflow: auto; margin-bottom: 15px;"
                              v-model="homePageObj.articleList"
                              group="people"
                              @start="drag = true"
                              @end="drag = false"
                            >
                              <div v-for="(task, index) in homePageObj.articleList" class="dragObj">
                                <div style="padding: 5px">
                                  <span style="display: inline-block">
                                    {{ $t("message.Article title:") }}
                                    {{ task["title" + $i18n.locale] }}
                                  </span>
                                </div>
                                <a
                                  class="pull-right btn btn-xs btn-white"
                                  style="position: absolute; top: 10px; right: 10px;"
                                  @click="deleteArticle(index)"
                                >
                                  {{ $t("message.Delete") }}
                                </a>
                              </div>
                            </draggable>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import eventBus from "../eventbus";
import config from "../config";
import draggable from "vuedraggable";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      isSave: false,
      language: "en_US",
      articleList: [],
      floatingBannerList: [],
      departmentBannerList: [],
      topBannerList: [],
      homePageObj: {
        bannerList: [],
        articleList: [],
        floatingBannerVoList: [],
        departmentBannerVoList: [],
        topBannerVoList: [],
      },
      articleId: "",
      floatingBannerId: "",
      departmentBannerId: "",
      topBannerId: "",
    };
  },
  created() {
    this.init();
    this.getArticleList();
    this.getFloatingBannerList();
    this.getDepartmentBannerList();
    this.getTopBannerList();
  },
  components: {
    draggable,
  },
  mounted() {
    var rnd = Date.now();
    document.getElementById("landingPage").src = process.env.VUE_APP_API_WEBDOMAIN + "/home/preview" + "?rnd=" + rnd + "&lang=" + this.language;
    this.reloadIframe = function () {
      document.getElementById("landingPage").src = "";
      setTimeout(function () {
        document.getElementById("landingPage").src =
          process.env.VUE_APP_API_WEBDOMAIN +
          "/home/preview" +
          "?rnd=" +
          rnd +
          "&lang=" +
          this.language;
      }, 100);
    };
  },
  methods: {
    async init() {
      let obj = this.getAuthObj;
      let data = await this.$store.dispatch("getHomePageDraft",this.setFormData(obj));
      for (var i = 0; i < data.data.result.bannerList.length; i++) {
        for (var j = 0; j < data.data.result.bannerList[i].langMap.length; j++) {
          if (data.data.result.bannerList[i].langMap[j].langCode == "en_US") {
            data.data.result.bannerList[i]["title" + "en_US"] = data.data.result.bannerList[i].langMap[j].title;
          }
          if (data.data.result.bannerList[i].langMap[j].langCode == "zh_HK") {
            data.data.result.bannerList[i]["title" + "zh_HK"] = data.data.result.bannerList[i].langMap[j].title;
          }
          if (data.data.result.bannerList[i].langMap[j].langCode == "zh_CN") {
            data.data.result.bannerList[i]["title" + "zh_CN"] = data.data.result.bannerList[i].langMap[j].title;
          }
        }
      }
      for (var i = 0; i < data.data.result.articleList.length; i++) {
        for (var j = 0; j < data.data.result.articleList[i].langMap.length; j++) {
          if (data.data.result.articleList[i].langMap[j].langCode == "en_US") {
            data.data.result.articleList[i]["title" + "en_US"] = data.data.result.articleList[i].langMap[j].title;
          }
          if (data.data.result.articleList[i].langMap[j].langCode == "zh_HK") {
            data.data.result.articleList[i]["title" + "zh_HK"] = data.data.result.articleList[i].langMap[j].title;
          }
          if (data.data.result.articleList[i].langMap[j].langCode == "zh_CN") {
            data.data.result.articleList[i]["title" + "zh_CN"] = data.data.result.articleList[i].langMap[j].title;
          }
        }
      }
      for (var i = 0; i < data.data.result.floatingBannerVoList.length; i++) {
        for (var j = 0; j < data.data.result.floatingBannerVoList[i].langMap.length; j++) {
          if (data.data.result.floatingBannerVoList[i].langMap[j].langCode == "en_US") {
            data.data.result.floatingBannerVoList[i]["bannerName" + "en_US"] = data.data.result.floatingBannerVoList[i].langMap[j].bannerName;
          }
          if (data.data.result.floatingBannerVoList[i].langMap[j].langCode == "zh_HK") {
            data.data.result.floatingBannerVoList[i]["bannerName" + "zh_HK"] = data.data.result.floatingBannerVoList[i].langMap[j].bannerName;
          }
          if (data.data.result.floatingBannerVoList[i].langMap[j].langCode == "zh_CN") {
            data.data.result.floatingBannerVoList[i]["bannerName" + "zh_CN"] = data.data.result.floatingBannerVoList[i].langMap[j].bannerName;
          }
        }
      }
      for (var i = 0; i < data.data.result.departmentBannerVoList.length; i++) {
        for (var j = 0; j < data.data.result.departmentBannerVoList[i].langMap.length; j++) {
          if (data.data.result.departmentBannerVoList[i].langMap[j].langCode == "en_US") {
            data.data.result.departmentBannerVoList[i]["bannerName" + "en_US"] = data.data.result.departmentBannerVoList[i].langMap[j].bannerName;
          }
          if (data.data.result.departmentBannerVoList[i].langMap[j].langCode == "zh_HK") {
            data.data.result.departmentBannerVoList[i]["bannerName" + "zh_HK"] = data.data.result.departmentBannerVoList[i].langMap[j].bannerName;
          }
          if (data.data.result.departmentBannerVoList[i].langMap[j].langCode == "zh_CN") {
            data.data.result.departmentBannerVoList[i]["bannerName" + "zh_CN"] = data.data.result.departmentBannerVoList[i].langMap[j].bannerName;
          }
        }
      }
      for (var i = 0; i < data.data.result.topBannerVoList.length; i++) {
        for (var j = 0; j < data.data.result.topBannerVoList[i].langMap.length; j++) {
          if (data.data.result.topBannerVoList[i].langMap[j].langCode == "en_US") {
            data.data.result.topBannerVoList[i]["topBannerName" + "en_US"] = data.data.result.topBannerVoList[i].langMap[j].topBannerName;
          }
          if (data.data.result.topBannerVoList[i].langMap[j].langCode == "zh_HK") {
            data.data.result.topBannerVoList[i]["topBannerName" + "zh_HK"] = data.data.result.topBannerVoList[i].langMap[j].topBannerName;
          }
          if (data.data.result.topBannerVoList[i].langMap[j].langCode == "zh_CN") {
            data.data.result.topBannerVoList[i]["topBannerName" + "zh_CN"] = data.data.result.topBannerVoList[i].langMap[j].topBannerName;
          }
        }
      }
      this.$set(this, "homePageObj", data.data.result);
    },
    async getArticleList() {
      let obj = this.getAuthObj;
      obj.sortField = "id";
      obj.sortType = "ASC";
      obj.startRow = 0;
      obj.maxRows = 10000;
      obj.states = 10;
      let data = await this.$store.dispatch("getArticleList",this.setFormData(obj));
      for (var i = 0; i < data.data.resultList.length; i++) {
        for (var j = 0; j < data.data.resultList[i].langMap.length; j++) {
          if (data.data.resultList[i].langMap[j].langCode == "en_US") {
            data.data.resultList[i]["title" + "en_US"] = data.data.resultList[i].langMap[j].title;
          }
          if (data.data.resultList[i].langMap[j].langCode == "zh_HK") {
            data.data.resultList[i]["title" + "zh_HK"] = data.data.resultList[i].langMap[j].title;
          }
          if (data.data.resultList[i].langMap[j].langCode == "zh_CN") {
            data.data.resultList[i]["title" + "zh_CN"] = data.data.resultList[i].langMap[j].title;
          }
        }
      }
      this.$set(this, "articleList", data.data.resultList);
    },
    async getFloatingBannerList() {
      let obj = this.getAuthObj;
      obj.startRow = 0;
      obj.maxRows = 10000;
      let data = await this.$store.dispatch("getFloatingBannerList", this.setFormData(obj));

      for(var i=0; i<data.data.resultList.length; i++) {
        for(var j=0; j<data.data.resultList[i].langMap.length; j++) {
          if( data.data.resultList[i].langMap[j].langCode=="en_US" ){
            data.data.resultList[i]['bannerName'+'en_US'] = data.data.resultList[i].langMap[j].bannerName;
          }
          if(data.data.resultList[i].langMap[j].langCode=="zh_HK"){
            data.data.resultList[i]['bannerName'+'zh_HK'] = data.data.resultList[i].langMap[j].bannerName;
          }
          if(data.data.resultList[i].langMap[j].langCode=="zh_CN"){
            data.data.resultList[i]['bannerName'+'zh_CN'] = data.data.resultList[i].langMap[j].bannerName;
          }
        }
      }
      this.$set(this, "floatingBannerList", data.data.resultList);
    },
    async getDepartmentBannerList() {
      let obj = this.getAuthObj;
      obj.startRow = 0;
      obj.maxRows = 10000;
      let data = await this.$store.dispatch("getDepartmentBannerList", this.setFormData(obj));

      for(var i=0; i<data.data.resultList.length; i++) {
        for(var j=0; j<data.data.resultList[i].langMap.length; j++) {
          if( data.data.resultList[i].langMap[j].langCode=="en_US" ){
            data.data.resultList[i]['bannerName'+'en_US'] = data.data.resultList[i].langMap[j].bannerName;
          }
          if(data.data.resultList[i].langMap[j].langCode=="zh_HK"){
            data.data.resultList[i]['bannerName'+'zh_HK'] = data.data.resultList[i].langMap[j].bannerName;
          }
          if(data.data.resultList[i].langMap[j].langCode=="zh_CN"){
            data.data.resultList[i]['bannerName'+'zh_CN'] = data.data.resultList[i].langMap[j].bannerName;
          }
        }
      }
      this.$set(this, "departmentBannerList", data.data.resultList);
    },
    async getTopBannerList() {
      let obj = this.getAuthObj;
      obj.startRow = 0;
      obj.maxRows = 10000;
      let data = await this.$store.dispatch("getTopBannerList", this.setFormData(obj));

      for(var i=0; i<data.data.resultList.length; i++) {
        for(var j=0; j<data.data.resultList[i].langMap.length; j++) {
          if( data.data.resultList[i].langMap[j].langCode=="en_US" ){
            data.data.resultList[i]['topBannerName'+'en_US'] = data.data.resultList[i].langMap[j].topBannerName;
          }
          if(data.data.resultList[i].langMap[j].langCode=="zh_HK"){
            data.data.resultList[i]['topBannerName'+'zh_HK'] = data.data.resultList[i].langMap[j].topBannerName;
          }
          if(data.data.resultList[i].langMap[j].langCode=="zh_CN"){
            data.data.resultList[i]['topBannerName'+'zh_CN'] = data.data.resultList[i].langMap[j].topBannerName;
          }
        }
      }
      this.$set(this, "topBannerList", data.data.resultList);
    },
    deleteBanner: function (index) {
      this.homePageObj.bannerList.splice(index, 1);
    },
    deleteArticle: function (index) {
      this.homePageObj.articleList.splice(index, 1);
    },
    deleteFloatingBanner: function (index) {
      this.homePageObj.floatingBannerVoList.splice(index, 1);
    },
    deleteDepartmentBanner: function (index) {
      this.homePageObj.departmentBannerVoList.splice(index, 1);
    },
    deleteTopBanner: function (index) {
      this.homePageObj.topBannerVoList.splice(index, 1);
    },
    async publishEvent() {
      let obj = this.getAuthObj;
      let data = await this.$store.dispatch("publishHomePage",this.setFormData(obj));
      this.init();
    },
    async saveEvent() {
      let obj = this.getAuthObj;
      let refIds = [];
      for (var i = 0; i < this.homePageObj.articleList.length; i++) {
        refIds.push(this.homePageObj.articleList[i].id);
      }
      if (refIds.length != 3) {
        this.$toastr.w(this.$i18n.t("message.Must be 3"), "Warning");
        return;
      }
      obj.refIds = refIds.join(",");

      let bannerRefIds = [];
      for (var i = 0; i < this.homePageObj.bannerList.length; i++) {
        bannerRefIds.push(this.homePageObj.bannerList[i].id);
      }
      if (bannerRefIds.length == 0 || bannerRefIds.length > 5) {
        this.$toastr.w(this.$i18n.t("message.MinimumMaximum"), "Warning");
        return;
      }
      obj.bannerRefIds = bannerRefIds.join(",");

      let floatingBannerrefIds = [];
      for (var i = 0; i < this.homePageObj.floatingBannerVoList.length; i++) {
        floatingBannerrefIds.push(this.homePageObj.floatingBannerVoList[i].id);
      }
      if (floatingBannerrefIds.length == 0 || floatingBannerrefIds.length > 5) {
        this.$toastr.w(this.$i18n.t("message.FloatingBannerNum"), "Warning");
        return;
      }
      obj.floatingBannerrefIds = floatingBannerrefIds.join(",");

      let departmentBannerrefIds = [];
      for (var i = 0; i < this.homePageObj.departmentBannerVoList.length; i++) {
        departmentBannerrefIds.push(this.homePageObj.departmentBannerVoList[i].id);
      }
      if (departmentBannerrefIds.length == 0) {
        this.$toastr.w(this.$i18n.t("message.DepartmentBannerNum"), "Warning");
        return;
      }
      obj.departmentBannerrefIds = departmentBannerrefIds.join(",");

      let topBannerrefIds = [];
      for (var i = 0; i < this.homePageObj.topBannerVoList.length; i++) {
        topBannerrefIds.push(this.homePageObj.topBannerVoList[i].id);
      }
      if (topBannerrefIds.length == 0 || topBannerrefIds.length > 20) {
        this.$toastr.w(this.$i18n.t("message.TopBannerNum"), "Warning");
        return;
      }
      obj.topBannerrefIds = topBannerrefIds.join(",");

      let data = await this.$store.dispatch("saveHomePageDraft", this.setFormData(obj));
      this.reloadIframe();
      this.init();
    },
    addArticle: function () {
      for (var i = 0; i < this.articleList.length; i++) {
        if (this.articleList[i].id == this.articleId) {
          this.homePageObj.articleList.push(this.articleList[i]);
        }
      }
      this.articleId = "";
    },
    addBanner: function () {
      for (var i = 0; i < this.articleList.length; i++) {
        if (this.articleList[i].id == this.articleId) {
          this.homePageObj.bannerList.push(this.articleList[i]);
        }
      }
      this.articleId = "";
    },
    addFloatingBanner: function () {
      for (var i = 0; i < this.floatingBannerList.length; i++) {
        if (this.floatingBannerList[i].id == this.floatingBannerId) {
          this.homePageObj.floatingBannerVoList.push(this.floatingBannerList[i]);
        }
      }
      this.floatingBannerId = "";
    },
    addDepartmentBanner: function () {
      for (var i = 0; i < this.departmentBannerList.length; i++) {
        if (this.departmentBannerList[i].id == this.departmentBannerId) {
          this.homePageObj.departmentBannerVoList.push(this.departmentBannerList[i]);
        }
      }
      this.departmentBannerId = "";
    },
    addTopBanner: function () {
      for (var i = 0; i < this.topBannerList.length; i++) {
        if (this.topBannerList[i].id == this.topBannerId) {
          this.homePageObj.topBannerVoList.push(this.topBannerList[i]);
        }
      }
      this.topBannerId = "";
    },
  },
};
</script>

<style scoped>
.content-row {
  display: flex;
  align-items: center;
  padding: 10px;
}
.btn-group {
  margin-left: 10px;
}
.btn-group .btn {
  margin: 0 10px;
}
.floatingBannerList {
  max-height: 900px;
  overflow: auto;
  margin-bottom: 15px;
  padding: 10px 0;
}
.departmentBannerList {
  max-height: 900px;
  overflow: auto;
  margin-bottom: 15px;
  padding: 10px 0;
}
.bannerLabel {
  width: 120px;
  margin-right: 10px;
}
</style>
